import React from 'react';
import { css } from '@emotion/css';
import Container from 'evcharging/components/Container';
import { Theme } from 'evcharging/app/themes';
import Paragraph from 'evcharging/components/Paragraph';
import Spacer from 'evcharging/components/Spacer';
import Box from 'evcharging/components/Box';
import charger from 'evcharging/assets/ev-charger/charger.png';
import header from 'evcharging/assets/ev-charger/header.png';
import { CONTACT_US_ANCHOR } from 'evcharging/app/seo/urls';
import LinkButton from 'evcharging/components/LinkButton';
import { useRouter } from 'next/router';
import useI18n from 'evcharging/hooks/useI18n';
import useTheme from 'evcharging/hooks/useTheme';

const EvChargerHeader = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { pathname } = useRouter();
  const { t } = useI18n();

  return (
    <header className={styles.root}>
      <Container>
        <div className={styles.content}>
          <div className={styles.inner}>
            <h1 className={styles.title}>{t('charger.header')}</h1>
            <Spacer value={4} />
            <Box maxWidth={520}>
              <Paragraph color={'light'}>{t('charger.intro')}</Paragraph>
            </Box>
            <Spacer value={16} />
            <Box>
              <LinkButton href={CONTACT_US_ANCHOR}>
                {t('form.lead.button')}
              </LinkButton>
            </Box>
            <Spacer value={450} />
          </div>
        </div>
      </Container>
    </header>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    background-image: url(${header});
    background-size: cover;
    color: #fff;
  `,
  content: css`
    position: relative;
    background-image: url(${charger});
    background-repeat: no-repeat;
    background-position: 10% bottom;
    padding-top: 50px;
    height: 746px;
    ${theme.breakpoints.mobile.down} {
      background-size: 45%;
      background-position: center bottom;
    }
    @media (max-width: 800px) {
      background-size: 50%;
      background-position: center bottom;
    }
    @media (max-width: 680px) {
      background-size: 55%;
      background-position: center bottom;
    }
    @media (max-width: 600px) {
      background-size: 72%;
      background-position: center bottom;
    }
    @media (max-width: 390px) {
      background-size: 90%;
      background-position: center bottom;
    }
  `,
  title: css`
    font-weight: 700;
    font-size: 48px;
    line-height: 60px;
    ${theme.breakpoints.mobile.down} {
      font-size: 32px;
      line-height: 40px;
    }
  `,
  inner: css`
    position: absolute;
    top: 300px;
    right: 50px;
    ${theme.breakpoints.mobile.down} {
      position: relative;
      top: auto;
      right: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding-top: 50px;
    }
  `,
});

export default EvChargerHeader;
